import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { defaultTheme } from '@dealstack/frontend/shared/mechanism/styleguide/defaultTheme';
import {
	ALL_INVESTMENTS,
	useInvestmentsDropdownController,
} from '@dealstack/frontend/investor/pages/Valuations/InvestmentsDropdown/useInvestmentsDropdownController';
import { Select } from '@mantine/core';
import { isEmpty } from 'lodash';
import styled from 'styled-components';

interface Props {
	className?: string;
}

const InvestmentsDropdown = ({ className }: Props) => {
	const { investments, onChange, selectedInvestment } = useInvestmentsDropdownController();

	if (!investments) {
		return null;
	}
	return (
		<Select
			maw={224}
			mx="auto"
			className={className}
			data={investments}
			value={isEmpty(selectedInvestment) ? ALL_INVESTMENTS : selectedInvestment}
			onChange={onChange}
			rightSection={<DropdownIcon variant="caret-down" size="sm" />}
			styles={{
				// v7 renamed the Input right-section part to `section`; the old
				// `rightSection` key is inert (caret swallowed clicks).
				section: {
					pointerEvents: 'none',
				},
			}}
		/>
	);
};

const DropdownIcon = styled(Icon)`
	color: ${defaultTheme.v3.colors.black[0]};
`;

const Styled = styled(InvestmentsDropdown)`
	input {
		font-weight: 600;
		font-size: 14px;
		color: ${defaultTheme.v3.colors.blue[6]};
	}
`;

export { Styled as InvestmentsDropdown };
